import { render, staticRenderFns } from "./DuplicateStep2SelectDeliverables.vue?vue&type=template&id=360fa06c&scoped=true&"
import script from "./DuplicateStep2SelectDeliverables.vue?vue&type=script&lang=js&"
export * from "./DuplicateStep2SelectDeliverables.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateStep2SelectDeliverables.vue?vue&type=style&index=0&id=360fa06c&lang=scss&scoped=true&"
import style1 from "./DuplicateStep2SelectDeliverables.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360fa06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360fa06c')) {
      api.createRecord('360fa06c', component.options)
    } else {
      api.reload('360fa06c', component.options)
    }
    module.hot.accept("./DuplicateStep2SelectDeliverables.vue?vue&type=template&id=360fa06c&scoped=true&", function () {
      api.rerender('360fa06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicateStep2SelectDeliverables.vue"
export default component.exports